import { bindActionCreators } from 'redux';
import React, { Component} from 'react';
import { connect } from 'react-redux';
import Header from '../layout/Header';
import TypeContent from './TypeContent';
import { Link } from 'react-router';
import * as userActions from '../../actions/user';



export default class YourTours extends Component {

    componentWillMount() {

    }

    componentDidMount() {



    }

    componentDidUpdate() {

    }


    componentWillUnmount() {
    }

    
    
    render () {

        return (

            <section className="section section__gallery types">
                <div className="blured__background blured__background_fixed types__blured types__blured_your"></div>

                    <Header />
                    <div className="container container_full-width">

                        <TypeContent type="your" actions={this.props.userActions} />
                    </div>
            </section>
        );
    }
}




function mapStateToProps(state) {
    //console.log(state);

    return {
        user: state.user
    };
}



function mapDispatchToProps(dispatch) {
    return {
        userActions: bindActionCreators(userActions, dispatch)
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(YourTours)






// WEBPACK FOOTER //
// ./src/common/components/type/Your.js